<template>
  <div>
    <b-card id="custom-drafts">
      <div
        slot="header"
        class="row col-12"
      >
        <h3>Borradores personalizados</h3>
      </div>
      <div class="row mb-3 align-items-end">
        <div class="col-md-4">
          <label>Tipo de documento</label>
          <select
            class="form-control"
            v-model="selectedType"
          >
            <option value="*">Selecciona un tipo</option>
            <option
              v-for="type in availableTypes"
              :key="type.value"
              :value="type.value"
            >
              {{ type.text || type.value }}
            </option>
          </select>
        </div>

        <div class="col-md-3 text-right">
          <vs-button
            color="primary"
            type="border"
            v-tooltip="'Refrescar listado'"
            icon="refresh"
            @click="fetchDocuments"
            :disabled="!selectedType"
          />
        </div>
      </div>
      <b-alert
        v-if="errorMessage"
        variant="danger"
        show
      >
        {{ errorMessage }}
      </b-alert>
      <b-alert
        v-if="!availableTypes.length"
        variant="warning"
        show
      >
        No hay tipos de documentos personalizados configurados para esta empresa.
      </b-alert>
      <b-alert
        v-else-if="!selectedType"
        variant="info"
        show
      >
        Selecciona un tipo para listar los borradores personalizados.
      </b-alert>
      <b-overlay
        v-if="selectedType"
        :show="loading"
        variant="white"
        blur="0"
        opacity="0.75"
        rounded="sm"
      >
        <div class="force-render" :key="forceRender">
          <table class="table table-hover b-table table-responsive">
            <thead>
            <tr>
              <th>Tipo</th>
              <th>Creado</th>
              <th>Estado</th>
              <th class="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!tableItems.length">
              <td colspan="4" class="text-center">Sin borradores personalizados</td>
            </tr>
            <tr
              v-for="row in tableItems"
              :key="row.id"
            >
              <td v-tooltip="row.type">{{ row.typeLabel || row.type }}</td>
              <td>{{ formatDate(row.createdAt) }}</td>
              <td>
                <vs-chip
                  v-if="row.statusLabel"
                  title="Borrador"
                >
                  <vs-avatar icon="query_builder" color="#87579e"/>
                  {{ row.statusLabel }}
                </vs-chip>
                <span v-else>-</span>
              </td>
              <td>
                <div class="d-flex justify-content-center">
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                  >
                    <template #button-content>
                      <feather-icon
                        width="20px"
                        height="20px"
                        icon="SettingsIcon"
                        class="align-middle text-body"
                      />
                    </template>
                    <b-dropdown-item
                      v-on:click="continueDocument(row)"
                    >
                      <vs-icon icon="query_builder"/>
                      Continuar documento
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-on:click="discardDocument(row)"
                    >
                      <vs-icon icon="remove_circle_outline"/>
                      Descartar documento
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
      <div class="row col-12" v-if="tableItems && tableItems.length">
        <div class="col-lg-4">
          <div class="mt-5">
            Mostrando
            <select v-model="rowspp">
              <option value="10" selected="selected">10</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="50">50</option>
            </select> registros por pagina.
          </div>
        </div>
        <div class="col-lg-8">
          <vs-row>
            <vs-col
              vs-w="12"
              class="mt-4"
            >
              <fb-paginacion
                :total="pagination.pages"
                v-model="page"
              />
            </vs-col>
          </vs-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';
import RepositoriesCustomTypeMixin from '@/febos/chile/commons/mixins/RepositoriesCustomTypeMixin';
import { ioDiscardCustomDocument, ioListCustomDocuments } from '@/febos/servicios/api/customDocuments.api';

export default {
  name: 'CustomDrafts',
  mixins: [RepositoriesCustomTypeMixin],
  components: {
    FbPaginacion
  },
  data() {
    return {
      loading: false,
      documents: [],
      tableItems: [],
      errorMessage: '',
      page: Number.parseInt(this.$route.query.page || 1, 10),
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      selectedType: this.$route.query.type || '*',
      searchText: '',
      pagination: {
        pages: 1,
        total: 0
      },
      forceRender: Date.now()
    };
  },
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    availableTypes() {
      return Array.isArray(this.optionsTypeDocument) ? this.optionsTypeDocument : [];
    }
  },
  watch: {
    tableItems() {
      this.forceRender = Date.now();
    },
    selectedType(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.documents = [];
      this.tableItems = [];
      this.pagination = { pages: 1, total: 0 };
      if (this.page !== 1) {
        this.page = 1;
        return;
      }
      this.fetchDocuments();
    },
    page(newValue, oldValue) {
      if (newValue === oldValue || !this.selectedType) return;
      this.fetchDocuments();
    },
    rowspp(newValue, oldValue) {
      if (newValue === oldValue || !this.selectedType) return;
      if (this.page !== 1) {
        this.page = 1;
        return;
      }
      this.fetchDocuments();
    },
    company: {
      handler() {
        if (!this.selectedType && this.availableTypes.length === 1) {
          this.selectedType = this.availableTypes[0].value;
        }
      },
      immediate: true
    }
  },
  mounted() {
    // if (this.selectedType) {
      this.fetchDocuments();
    // }
    const { type } = this.$route.query;
    if (type) {
      this.selectedType = type;
    }
  },
  methods: {
    async fetchDocuments() {
      if (!this.selectedType) return;

      this.loading = true;
      this.errorMessage = '';
      try {
        const response = await ioListCustomDocuments(this.selectedType, {
          paginaActual: this.page,
          elementosPorPagina: this.rowspp,
          aplicacion: 'ED',
          filtros: `status:3|createdBy:${this.currentUserId}` // Solo borradores
        });

        const data = response.data || {};
        const docs = data.documents || data.documentos || [];
        const totalPages = Number(data.totalPaginas || data.totalPages || 0);
        const totalElements = Number(data.totalElementos || data.totalElements || 0);

        this.documents = docs;
        this.tableItems = this.buildTableItems(docs);
        this.pagination = {
          pages: totalPages > 0 ? totalPages : 1,
          total: totalElements || docs.length
        };
      } catch (error) {
        this.errorMessage = error?.message || 'No se pudo cargar la lista.';
      } finally {
        this.loading = false;
      }
    },
    buildTableItems(docs) {
      // const filtered = this.filterDocuments(docs);
      return docs.map((doc) => ({
        id: doc.id || doc.documentId || doc._id || doc.febosId || '',
        type: doc.documentType || doc.type || doc.tipo || this.selectedType,
        typeLabel: this.resolveTypeLabel(doc),
        number: doc.numero || doc.number || doc.folio || '',
        createdAt: doc.createdAt || doc.fechaCreacion || doc.created_at || doc.fecha,
        statusLabel: this.resolveStatusLabel(doc),
        raw: doc
      }));
    },
    filterDocuments(docs) {
      if (!Array.isArray(docs) || !docs.length) return [];

      const hasCreatorField = docs.some((doc) => (
        doc.createdBy !== undefined
        || doc.creatorId !== undefined
        || doc.usuarioId !== undefined
        || doc.userId !== undefined
        || doc.createdById !== undefined
      ));

      const byUser = hasCreatorField
        ? docs.filter((doc) => this.isFromCurrentUser(doc))
        : docs;

      const hasDraftField = byUser.some((doc) => (
        doc.status !== undefined
        || doc.estado !== undefined
        || doc.statusCode !== undefined
        || doc.state !== undefined
        || doc.borrador !== undefined
        || doc.isDraft !== undefined
      ));

      return hasDraftField
        ? byUser.filter((doc) => this.isDraft(doc))
        : byUser;
    },
    formatDate(value) {
      if (!value) return '-';
      if (Vue.moment && Vue.moment(value).isValid()) {
        return Vue.moment(value).format('DD-MM-YYYY HH:mm');
      }
      return value;
    },
    resolveStatusLabel(doc) {
      const label = doc.statusDescription || doc.estadoDescripcion || doc.statusLabel;
      if (label) return label;

      const status = doc.status ?? doc.estado ?? doc.statusCode ?? doc.state;
      if (status === 3 || status === '3') return 'Borrador';

      return status !== undefined ? String(status) : '';
    },
    resolveTypeLabel(doc) {
      const rawType = doc.type
        ?? doc.tipo
        ?? doc.documentType
        ?? this.selectedType;

      if (!rawType) return '';

      const normalized = String(rawType).toLowerCase();

      const match = this.availableTypes.find((option) => (
        String(option.value).toLowerCase() === normalized
      ));
      if (match) return match.text || match.value || '';

      const matchByText = this.availableTypes.find((option) => (
        String(option.text).toLowerCase() === normalized
      ));
      if (matchByText) return matchByText.text || matchByText.value || '';

      return String(rawType);
    },
    async confirmDiscard(file) {
      try {
        this.$bvToast.toast(
          'Descartando borrador de documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );

        await ioDiscardCustomDocument(file.documentType, file.id);
        setTimeout(() => {
          this.$bvToast.toast(
            'Borrador descartado',
            {
              title: '¡Listo!',
              variant: 'success',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 3000
            },
          );
          this.fetchDocuments();
          this.saving = false;
        }, 2000);
      } catch (e) {
        this.saving = false;
      }
    },
    discardDocument(row) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '¡Heey!',
        text: '¿Estás seguro de que deseas descartar este borrador?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          await this.confirmDiscard(row.raw);
        },
        cancel: () => {
        }
      });
    },
    continueDocument(row) {
      const documentId = row.id || row.raw?.id || row.raw?.documentId;
      const type = row.type || row.raw?.documentType || this.selectedType;

      if (!documentId || !type) {
        return;
      }

      const query = {
        documentId,
      };

      if (row.raw?.locationType) {
        query.locationType = row.raw.locationType;
      }
      if (row.raw?.locationId) {
        query.locationId = row.raw.locationId;
      }

      this.$router.push({
        name: 'edit-custom-document',
        params: { type, from: 'draft' },
        query: {
          ...query,
          from: 'draft'
        }
      });
    },
    isDraft(doc) {
      if (doc.borrador === true || doc.isDraft === true) return true;

      const status = doc.status ?? doc.estado ?? doc.statusCode ?? doc.state;
      if (status === 3 || status === '3') return true;

      const label = String(doc.statusDescription || doc.estadoDescripcion || '').toLowerCase();
      return label.includes('borrador');
    },
    isFromCurrentUser(doc) {
      if (!this.currentUserId) return true;

      const creator = doc.createdBy
        ?? doc.creatorId
        ?? doc.usuarioId
        ?? doc.userId
        ?? doc.createdById;

      if (creator === undefined || creator === null) return true;

      return String(creator) === String(this.currentUserId);
    }
  }
};
</script>
